import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from "@angular/forms";
import { Subscription } from "rxjs";
import { AuthService } from "../authServices";
import { NgxSpinnerService } from "ngx-spinner";
import { FcmService } from 'src/app/fcm.service';

@Component({
  selector: 'vex-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
   hide = true;
   public showPassword: boolean = false;
   isLoading = false;
   private authStatusSub: Subscription;
   rememberMe: boolean = false;
   constructor(public authService: AuthService,
               private router : Router, private spinner: NgxSpinnerService,
              //  private fcmService: FcmService
              ) {}
 
   ngOnInit() {
     this.authStatusSub = this.authService.getAuthStatusListener().subscribe(
       authStatus => {
         this.isLoading = false;
       }
     );
    //  this.requestNotificationPermission();
   }
 
   onLogin(form: NgForm) {
    if (form.invalid) {
      return;
    }
    this.isLoading = true;
    this.authService.login(form.value.email, form.value.password, this.rememberMe);
  
  }
  
   public togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  // requestNotificationPermission() {
  //   if (Notification.permission === 'default') {
  //     alert("Please allow notifications for better experience.");
  //     this.fcmService.requestPermission().catch((error) => {
  //       console.error('Error requesting notification permission:', error);
  //     });
  //   } else if (Notification.permission === 'denied') {
  //     alert("You have blocked notifications. Please enable them in browser settings.");
  //   }
  // }

  btnClick() {
    this.router.navigate(['/forgot-password']);
  }
 
   ngOnDestroy() {
     this.authStatusSub.unsubscribe();
   }
}
